import axiosSetup from "../utils/axiosSetup";

export const uploadToS3ForCronJobApi = async (file: FormData) => {
  const response = await axiosSetup.post("/s3/uploadDataToS3", file);
  return response.data?.data;
};

export const deleteAllObjectsFromS3BucketApi = async (bucketName: string) => {
  const response = await axiosSetup.post("/s3/deleteAllObjectsFromS3Bucket", {
    bucketName,
  });
  return response.data?.data;
};
